import React, { useEffect, useState } from "react";
import { Form, Input, InputNumber, DatePicker } from "antd";
import moment from "moment";
import axios from "axios";
import { Error, Success } from "../../Messages/Messages";
import GeneralModal from "../../../serviceProvider/components/General.modal";
import MainButtonComp from "../../Buttons/MainButtonComp";
import { generalErrorAlert } from "../../GeneralErrorAlert";

import { useTranslation } from "react-i18next";
const { TextArea } = Input;

const UpdateSalarySlipModal = ({ disabled, formData, refreshParent }) => {
  const { t } = useTranslation("dashboard");
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (formData) {
      form.setFieldsValue({
        ...formData,
        startDate: formData.startDate ? moment(formData.startDate) : null,
        endDate: formData.endDate ? moment(formData.endDate) : null
      });
    }
  }, [formData, form]);

  const handleFinish = async values => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/salary-slips/update/${formData._id}`,
        {
          ...values,
          startDate: values.startDate?.toISOString(),
          endDate: values.endDate?.toISOString()
        },
        {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") }
        }
      );

      if (response.status === 200 || response.status === 304) {
        Success(t("Salary slip updated successfully!"));
        refreshParent(response.data.salarySlip);
        handleCancel();
      } else {
        Error(response.data.errorMessage);
      }
    } catch (err) {
      generalErrorAlert(err);
    }
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <MainButtonComp disabled={disabled && "Disabled"} text="Edit" editBtn onClick={showModal} />
      <GeneralModal
        title={t("Update Salary Slip")}
        onOk={() => form.submit()}
        open={isModalOpen}
        okText={t("Update")}
        onCancel={handleCancel}
        items={[
          {
            key: "1",
            label: t("Salary Slips"),
            children: (
              <Form form={form} layout="vertical" onFinish={handleFinish}>
                <Form.Item name="title" label={t("Title")} rules={[{ required: true }]}>
                  <Input placeholder={t("Enter title")} />
                </Form.Item>

                <Form.Item name="startDate" label={t("Start Date")} rules={[{ required: true }]}>
                  <DatePicker style={{ width: "100%" }} />
                </Form.Item>

                <Form.Item name="endDate" label={t("End Date")} rules={[{ required: true }]}>
                  <DatePicker style={{ width: "100%" }} />
                </Form.Item>

                <Form.Item
                  name="totalSalary"
                  label={t("Total Salary")}
                  rules={[{ required: true }]}
                >
                  <InputNumber style={{ width: "100%" }} />
                </Form.Item>

                <Form.Item
                  name="totalHoursWorked"
                  label={t("Total Hours Worked")}
                  rules={[{ required: true }]}
                >
                  <InputNumber style={{ width: "100%" }} />
                </Form.Item>

                <Form.Item name="totalUnpaidLeaves" label={t("Total Unpaid Leaves")}>
                  <InputNumber style={{ width: "100%" }} />
                </Form.Item>

                <Form.Item name="unpaidLeaveDeduction" label={t("Unpaid Leave Deduction")}>
                  <InputNumber style={{ width: "100%" }} />
                </Form.Item>

                <Form.Item
                  name="finalTotalSalary"
                  label={t("Final Total Salary")}
                  rules={[{ required: true }]}
                >
                  <InputNumber style={{ width: "100%" }} />
                </Form.Item>

                <Form.Item name="description" label={t("Description")}>
                  <TextArea rows={3} placeholder={t("Enter description")} />
                </Form.Item>
              </Form>
            )
          }
        ]}
      />
    </>
  );
};

export default UpdateSalarySlipModal;
